/**
 * @param {RouterTab} tab - RouterTab object with permissions that may include featureFlagName as string or string[]
 * @param {Function} getSettingOrDefinitionValue
 * @returns {boolean}
 */
export const filterByFeatureFlag = (tab, getSettingOrDefinitionValue) => {
  const ffName = tab?.permissions?.featureFlagName;
  if (!ffName) return true;

  // Handle array of feature flags (AND logic - all must be true)
  if (Array.isArray(ffName)) {
    return ffName.every(flagName => {
      const ffValue = getSettingOrDefinitionValue({ name: flagName });
      return ffValue;
    });
  }

  // Handle single feature flag (existing behavior)
  const ffValue = getSettingOrDefinitionValue({ name: ffName });
  return ffValue;
};

/**
 * @param {RouterTab} tab
 * @param {number} pmProvider
 * @returns {boolean}
 */
export const filterTabByPmProvider = (tab, pmProvider) => {
  const supportedPmProviders = tab?.permissions?.pmProviders || [];

  if (supportedPmProviders?.length === 0) return true;
  return supportedPmProviders.includes(pmProvider);
};

/**
 * @param {RouterTab} tab
 * @param {number} gitProvider
 * @returns {boolean}
 */
export const filterTabByGitProvider = (tab, gitProvider) => {
  const supportedGitProviders = tab?.permissions?.gitProviders || [];

  if (supportedGitProviders?.length === 0) return true;
  return gitProvider.some(provider => supportedGitProviders.includes(provider));
};

/**
 * @param {RouterTab} tab
 * @param {number} accountType
 * @returns {boolean}
 */
export const filterTabByAccountType = (tab, accountType) => {
  const supportedAccountTypes = tab?.permissions?.accountTypes || [];

  if (supportedAccountTypes?.length === 0) return true;
  return supportedAccountTypes.includes(accountType);
};

/**
 * @param {RouterTab} tab
 * @returns {boolean}
 */
export const filterTabByCondition = tab => {
  const condition = tab?.permissions?.condition;
  if (condition === undefined) return true;

  return condition;
};
